import React from "react";
import { connect } from "react-redux";
import Moment from "react-moment";
import ZeeTable from "components/ZeeTable";

import StockLedgerService from "services/stock-ledger";

import { updateLedger, createLedger, removeLedger } from "reducers/stock";

class StockLedger extends React.Component {
  stockLedgerService = new StockLedgerService();

  columns = {
    amount: {
      name: "Amount",
      format: (amount, row) => {
        return this.formatAmount(row).toFixed(2);
      },
    },
    description: { name: "Description" },
    updated: {
      name: "Updated",
      noEdit: true,
      format: (unix) =>
        unix && (
          <Moment unix format="DD/MM/YY HH:mm:ss">
            {unix}
          </Moment>
        ),
    },
    created: {
      name: "Created",
      noEdit: true,
      format: (unix) =>
        unix && (
          <Moment unix format="DD/MM/YY HH:mm:ss">
            {unix}
          </Moment>
        ),
    },
  };

  get currentId() {
    return this.props.stock.id || null;
  }

  get currentItem() {
    return this.props.stock || null;
  }

  get data() {
    return this.props.stockLedger.filter(
      (item) => item.stock_id === this.currentId
    );
  }

  async onDelete(stock) {
    const result = await this.stockLedgerService
      .delete(stock)
      .then(({ data }) => data);

    if (result.success) {
      this.props.removeLedger(result.data);
      return result.data;
    }
    return false;
  }

  async onEdit(stock) {
    if (stock.amount > 0) {
      stock.amount_in = stock.amount;
      stock.amount_out = 0;
    } else {
      stock.amount_out = Math.abs(stock.amount);
      stock.amount_in = 0;
    }

    delete stock.amount;

    const result = await this.stockLedgerService
      .update(stock)
      .then(({ data }) => data);

    if (result.success) {
      this.props.updateLedger(result.data);
      return result.data;
    }
    return false;
  }

  async onAdd(stock) {
    stock = { ...stock, stock_id: this.currentId };

    if (stock.amount > 0) {
      stock.amount_in = stock.amount;
      stock.amount_out = 0;
    } else {
      stock.amount_out = Math.abs(stock.amount);
      stock.amount_in = 0;
    }

    delete stock.amount;

    const result = await this.stockLedgerService
      .create(stock)
      .then(({ data }) => data);

    if (result.success) {
      this.props.createLedger(result.data);
      return result.data;
    }
    return false;
  }

  formatAmount(row) {
    if (!row.amount_in || !row.amount_out) {
      return 0;
    }

    const amountIn = parseFloat(row.amount_in);
    const amountOut = parseFloat(-row.amount_out);

    if (amountIn > 0) {
      return amountIn;
    }

    return amountOut;
  }

  getLevels() {
    let totalIn = 0;
    let totalOut = 0;
    let currentLevel = 0;

    this.data.forEach((item) => {
      const amount = this.formatAmount(item);
      if (amount > 0) {
        totalIn = totalIn + amount;
      } else {
        totalOut = totalOut + amount;
      }
      currentLevel = currentLevel + amount;
    });

    return {
      totalIn,
      totalOut,
      currentLevel,
    };
  }

  render() {
    if (this.currentItem) {
      return (
        <ZeeTable
          title="Ledger"
          columns={this.columns}
          data={this.data}
          hasSort={true}
          orderBy="created"
          hasAdd={true}
          hasDelete={true}
          hasEdit={true}
          hasPagination={true}
          onEdit={(stock) => this.onEdit(stock)}
          onDelete={(stock) => this.onDelete(stock)}
          onAdd={(stock) => this.onAdd(stock)}
        />
      );
    }

    return null;
  }
}

export default connect(
  (state) => {
    return {
      stockLedger: state.stock.ledger.all,
    };
  },
  { updateLedger, createLedger, removeLedger }
)(StockLedger);
